import { Dialog } from '@shigo-ui/ui';

import type { TailoredSupplyItem } from '../../../supply/tailored-supply/model';
import { ManageTailoredSupplyDialogContent } from './ManageTailoredSupplyDialogContent';

export function ManageTailoredSupplyDialog({
  onConfirm,
  onOpenChange,
  open,
  selectedItems,
}: {
  onConfirm: (items: TailoredSupplyItem[]) => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  selectedItems: TailoredSupplyItem[];
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {open ? (
        <ManageTailoredSupplyDialogContent
          key={selectedItems.map((item) => item.id).join(':')}
          selectedItems={selectedItems}
          onCancel={() => {
            onOpenChange(false);
          }}
          onConfirm={(items) => {
            onConfirm(items);
            onOpenChange(false);
          }}
        />
      ) : null}
    </Dialog>
  );
}
